// Shared by every "Book Appointment" entry point that already knows which
// doctor was picked (doctor profile page, doctor listing card) — writes the
// same localStorage keys AppointmentForm reads on mount, so the booking form
// opens with Doctor/Department already filled in instead of asking the
// patient to pick them again.
//
// `doctor` is a GET /doctors/{id} response: { id, name, degree, specialist,
// departments: [{department_id, department_name}], default_department }.
//
// Location is deliberately never touched here. It isn't a doctor property —
// it's purely the patient's own choice of which timezone to view/book times
// in (India vs USA), independent of which doctor or department they picked.
// So it's left exactly as whatever the patient already had selected, same as
// any other booking entry point, and is never locked.
//
// A doctor can belong to more than one department, so:
//   - exactly one department -> fill it in AND lock Department (nothing else
//     to choose)
//   - more than one          -> fill in a sensible default but leave
//     Department editable
//   - zero (not linked to any department) -> only the doctor identity can be
//     prefilled; Department is left for the patient to pick
export function prefillDoctorForBooking(doctor) {
  if (!doctor?.id) return;

  localStorage.setItem("selectedDoctorId", String(doctor.id));
  localStorage.setItem(
    "selectedDoctor",
    JSON.stringify({
      id: doctor.id,
      name: doctor.name || "",
      degree: doctor.degree || "",
      specialist: doctor.specialist || "",
    })
  );

  const departments = doctor.departments || [];
  const chosen = departments.length === 1 ? departments[0] : doctor.default_department;

  if (chosen) {
    localStorage.setItem("selectedSpeciality", String(chosen.department_id));
  }

  localStorage.setItem("selectedDoctorLocked", departments.length === 1 ? "true" : "false");
}
